import React, {useState} from 'react';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';

import BasketInfo from '../BasketInfo';

import styles from './PricesInfo.module.scss';

const cx = classnames.bind(styles);

const PricesInfo = ({
  className,
  mainPrice,
  secondaryPrice,
  basketData,
  reminderInfo,
  popInConditions,
  isDesktop = true,
}) => {
  const [isDetailedDisplay, setIsDetailedDisplay] = useState(false)

  const toggleDetailedInfo = function () {
    if (!isDesktop) {
      setIsDetailedDisplay(val => !val)
    }
  }

  return (
    <div className={cx('root', className)}>
      <div
        onClick={toggleDetailedInfo}
        className={cx('main-info', {active: isDetailedDisplay, interactive: !isDesktop})}
        onKeyDown={() => ''}
        role="button"
        tabIndex="0"
      >
        {mainPrice && (
          <div className={cx('section')}>
            <p className={cx('label')}>
              {mainPrice.label}
            </p>
            <p className={cx('price')}>
              {mainPrice.price}
              {mainPrice.additionalPrice && (
                <span className={cx('alternative-price')}>
                {mainPrice.additionalPricePrefix}
                  {' '}
                  {mainPrice.additionalPrice}
              </span>
              )}
            </p>
          </div>
        )}
        {secondaryPrice ? (
          <div className={cx('section')}>
            {/* eslint-disable-next-line */}
            <p className={cx('label')}>
              {secondaryPrice.label}
            </p>
            {secondaryPrice.price && (
              <p className={cx('price')}>
                {secondaryPrice.price}
                {secondaryPrice.additionalPrice && (
                  <span className={cx('alternative-price')}>
                  {secondaryPrice.additionalPricePrefix}
                    {' '}
                    {secondaryPrice.additionalPrice}
                </span>
                )}
              </p>
            )}
          </div>
        ) : null}
      </div>
      {isDetailedDisplay && !isDesktop && (
        <BasketInfo
          data={basketData}
          className={cx('basket-details')}
          reminderInfo={reminderInfo}
          popInConditions={popInConditions}
          isDetailsOpened
          isReminderInfoDisplay
        />
      )}
    </div>
  )
}

PricesInfo.propTypes = {
  className: PropTypes.string,
}

PricesInfo.defaultProps = {
  className: '',
}

export default PricesInfo;
